import { useTranslation } from 'next-i18next'
import dynamic from 'next/dynamic'
import React, { useState } from 'react'
import { useFilterProvider } from '../../context/FilterProvider'
import IconMenu from '../IconMenu'
import { SearchFilters } from '../SearchBar/types'

const Drawer = dynamic(() => import('../LandingNav/Drawer'))
const MobileSearchBar = dynamic(() => import('../SearchBar/MobileSearchBar'))

type INavBarProps = {
  onSearch?: (filters: SearchFilters) => void
}

function MobileNavBar({ onSearch }: INavBarProps) {
  const { t } = useTranslation('nav')
  const [isOpen, setIsOpen] = useState(false)
  const { filtersOpen, setFiltersOpen } = useFilterProvider()

  return (
    <div
      className={`fixed z-[1299] w-full border-b border-ink-100/15 bg-white-500 transition-shadow duration-200 ${
        isOpen ? 'shadow-none' : 'shadow-sm'
      }`}
    >
      <div className="flex h-(--nav-h) items-center gap-2 px-2.5 sm:px-4">
        {/* Left: Logo / Menu */}
        <div className="shrink-0">
          <IconMenu
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            icon="/logos/logo-icon-blue.png"
            size={36}
          />
        </div>

        {/* Center: Search Bar */}
        <div className="min-w-0 flex-1">
          {!isOpen && <MobileSearchBar onSearch={onSearch} />}
        </div>

        {/* Right: Filter Toggle */}
        {!isOpen && (
          <button
            type="button"
            onClick={() => setFiltersOpen(!filtersOpen)}
            aria-expanded={filtersOpen}
            className={`flex size-9 shrink-0 items-center justify-center rounded-full border shadow-sm transition-colors duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 ${
              filtersOpen
                ? 'border-blue-800/40 bg-blue-500/10 text-blue-800'
                : 'border-ink-100/20 bg-white-500 text-ink-700 hover:border-ink-100/40 hover:bg-cream-300'
            }`}
            aria-label={t('SEARCH.FILTERS')}
          >
            <i
              className={`si ${filtersOpen ? 'si-close' : 'si-sliders'} text-sm`}
            />
          </button>
        )}
      </div>

      <Drawer isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  )
}

export default React.memo(MobileNavBar)
